// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sDruY","col":"styles_col__1FIhY"};